import { css } from 'styled-components';

export default css`
    .about-validation ul {
        list-style: initial;
        padding: 0 4rem;
    }
`;
